export default "__VITE_ASSET__DE4Bd0JW__"